<ng-container *ngIf="isBaggageAvailable && contentBaggage$ | async as contentBaggage">
  <accordion class="accordion-container">
    <accordion-group [panelClass]="'custom-class'" [isOpen]="expandExtras === extrasTypesEnum.Baggage">
      <div accordion-heading class="heading-bagage">
        <img
          *ngIf="contentBaggage?.baggageIcon"
          [src]="contentBaggage.baggageIcon.url"
          [alt]="contentBaggage.baggageIcon.title"
          class="ml-2 mr-3"
        />
        <span class="bagage-title font-weight-bold mt-1">{{ contentBaggage?.baggageTitle }}</span>
        <ng-content select="[header-extra-content]"></ng-content>
      </div>

      <form [formGroup]="baggageForm">
        <div class="baggage-selector" formArrayName="passengersBaggage">
          <label>{{ contentBaggage?.selectBagage }}</label>
          <p class="sub-text mt-2">{{ contentBaggage?.baggageExtra }}</p>

          <div class="row" *ngFor="let passenger of extrasInfo?.passengers as passengers; let i = index" [formGroupName]="i">
            <div class="col-5 mt-2">
              <label>{{ passenger?.passengerDetails?.firstName }} {{ passenger?.passengerDetails?.lastName }}</label>
              <span class="passenger-date ml-2">{{ passenger.passengerDetails.dateOfBirth | formatDate }}</span>
            </div>
            <div class="col-7 select-box d-flex align-items-center mb-3 select-box">
              <div *ngIf="loading && loadingIndex === i" class="spinner-border spinner-border-sm mr-2 spinner-extras" role="status"></div>
              <ng-container *ngIf="!baggageForm.get('passengersBaggage').get(i.toString()).get('isInfant').value; else infantMessage">
                <select
                  formControlName="baggageOptionCode"
                  class="baggage-select form-control"
                  [class.disabled-select]="loading"
                  (click)="loading ? $event.preventDefault() : null"
                  (change)="selectBaggage(passenger?.passengerIdentifier, i)"
                >
                  <option
                    *ngFor="let option of passenger?.passengerExtras[0]?.options"
                    [value]="option?.bookingReference"
                    [selected]="option?.isSelected"
                  >
                    {{ option.bookingReference === defaultPlaceholderReference ? contentBaggage.dropdownPlaceholder : option?.displayText }}
                    €{{ option?.displayPrice | formatDecimals : culture }}
                  </option>
                </select>
              </ng-container>
              <ng-template #infantMessage>
                <p>{{ 'EXTRAS_PAGE.INFANT_MESSAGE' | translate }}</p>
              </ng-template>
            </div>
          </div>
        </div>
      </form>
    </accordion-group>

    <div *ngIf="extrasInfo?.priceInfo?.totalPrice" class="total-cost d-flex align-items-center">
      <p class="text-right align-items-center w-100 mr-4 mb-0">
        {{ contentBaggage?.baggageTotal }}:
        <span class="font-weight-bold">
          € {{ extrasInfo?.priceInfo?.pricePerProduct?.baggageTotalDisplayPrice | formatDecimals : culture }}
        </span>
      </p>
    </div>
  </accordion>
</ng-container>
